import { ChangeEvent, KeyboardEvent, useEffect, useRef } from "react";

interface IToggleProps {
    onChange: Function,
    isChecked: boolean,
    width?: number,
    height?: number,
    handleColor?: string,
    text?: string,
    textClasses?: string,
    textStyles?: any,
    padding?: number,
    isPositionRight?: boolean,
}

/**
 * Toggle widget.
 */
export const Toggle = (props: IToggleProps) => {
    const padding = props.padding || 2;
    const width = props.width || 70;
    const height = props.height || 26;
    const handleSize = height - padding - padding * 2;
    const handleColor = props.handleColor || '#686868';

    const textRef = useRef<HTMLSpanElement>(null);

    useEffect(() => {
        const $root = document.querySelector(':root') as HTMLElement;
        if(!$root) return;

        const translateXHandle = width - padding * 3 - handleSize;
        $root.style.setProperty('--toggle-switch-translatex-handle', `${ translateXHandle }px`);

        if(!textRef || !textRef.current) return;

        const translateXText = -(width - padding * 3 - textRef.current.offsetWidth);
        $root.style.setProperty('--toggle-switch-translatex-text', `${ translateXText }px`);
    });

    const onChange = (evt: ChangeEvent<HTMLInputElement>) => {
        props.onChange(evt.target.checked);
    };

    const onKeyUp = (evt: KeyboardEvent<HTMLInputElement>) => {
        if(evt.key === 'Enter') {
            evt.preventDefault();
            props.onChange(!props.isChecked);
        }
    };

    let checkedPositionClass = props.isChecked ? 'toggle-switch__checked' : '';
    if(props.isPositionRight){
        checkedPositionClass = props.isChecked ? '' : 'toggle-switch__checked';
    }

    return (
        <label
            className={`toggle-switch ${ checkedPositionClass } border rounded-3xl bg-white block cursor-pointer flex relative`}
            style={{
                width: `${width}px`,
                height: `${height}px`,
                padding: `${padding}px`,
            }}>

            <input
                className="absolute"
                checked={ props.isChecked }
                style={{
                    opacity: 0,
                    width: 0,
                    height: 0,
                }}
                type="checkbox"
                autoComplete="off"
                onChange={ onChange }
                onKeyUp={ onKeyUp }
            />

            <span
                className="toggle-switch__handle block"
                style={{
                    width: `${handleSize}px`,
                    height: `${handleSize}px`,
                    borderRadius: '100%',
                    backgroundColor: handleColor,
                }}
            />
            {
                props.text &&
                <span
                    ref={ textRef }
                    className={`toggle-switch__text relative flex items-center flex-1 text-center justify-center text-xs font-normal text-center text-gray-500 ${ props.textClasses }`}
                    style={ props.textStyles }
                >{ props.text }</span>
            }
            <span className="sr-only">Toggle</span>
        </label>
    )
};